import useSWR from "swr";

interface ProductImageResponse {
  WDCatalogImage: string | null;
  WDCatalogImageFileName: string | null;
}

const fetcher = (url: string): Promise<ProductImageResponse> =>
  fetch(url).then((r) => {
    if (!r.ok) throw new Error(`product image fetch failed: ${r.status}`);
    return r.json();
  });

export function useProductImage(eCommerceURL?: string | null) {
  const key = eCommerceURL
    ? `/api/method/products/image?url=${encodeURIComponent(eCommerceURL)}`
    : null;

  const { data, error, isValidating } = useSWR<ProductImageResponse>(key, fetcher, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    dedupingInterval: 60 * 60 * 1000, // 1h — catalog images change rarely
  });

  return {
    WDCatalogImage: data?.WDCatalogImage ?? undefined,
    WDCatalogImageFileName: data?.WDCatalogImageFileName ?? undefined,
    isLoading: !!key && !data && !error && isValidating,
    error,
  };
}
